import { POST_LOGIN_PATH_LOCAL_STORAGE_KEY, TRIGGER_LOGIN } from '@common/utils'
import { useCallback, useEffect } from 'react'
import { useAuth } from 'react-oidc-context'
import { handleEventListener } from '@/utils/nav-functions'

export const useCustomEventCommunication = () => {
  const auth = useAuth()

  const handleSignIn = useCallback(() => {
    const currentPath = window.location.pathname + window.location.search
    localStorage.setItem(POST_LOGIN_PATH_LOCAL_STORAGE_KEY, currentPath)

    auth.signinRedirect()
  }, [auth.signinRedirect])

  useEffect(() => {
    handleEventListener(TRIGGER_LOGIN, handleSignIn, 'add')

    return () => {
      handleEventListener(TRIGGER_LOGIN, handleSignIn, 'remove')
    }
  }, [handleSignIn])

  return { handleSignIn }
}
